import { call, put, select } from 'redux-saga/effects';

import { Messages } from '../../../../codegen/Localize';
import { IDataSourceBase } from '../../../../datasource/models/IDataSourceInfo';
import { RefreshPropertyHelper } from '../../../../ts/helpers/RefreshPropertyHelper';
import { IRemoteRefreshScheduleInfo } from '../../../../ts/models/IRemoteRefreshScheduleInfo';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { ChangeRemoteExtractRefreshAction } from '../../../actions/spaces/ChangeRemoteExtractRefreshAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { EditRemoteRefreshScheduleAction } from '../../../content/EditRemoteRefreshScheduleAction';
import { selectSpaceInfoItem } from '../../../selectors/SpaceInfoSelectors';

export function* handleChangeRemoteExtractRefreshAction(action: ChangeRemoteExtractRefreshAction) {
  try {
    const datasource: IDataSourceBase = yield select(selectSpaceInfoItem);
    yield call(executeChangeRemoteExtractRefreshAction, datasource, action.schedule);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeChangeRemoteExtractRefreshAction(
  datasource: IDataSourceBase,
  item: IRemoteRefreshScheduleInfo
) {
  const availableTypes = RefreshPropertyHelper.getAvailableRefreshTypes(datasource);
  return EditRemoteRefreshScheduleAction.execute(datasource, item, availableTypes);
}
